import {Component, Inject} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({ selector: 'storever-access-denied', templateUrl: './access-denied.component.html', styleUrls: ['./access-denied.component.scss'] })
export class AccessDeniedComponent {
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}
}
